import { useMemo } from 'react';
import { useGetCustomersQuery } from '@/lib/api/lookupsApi';
import { useModuleLookups } from '@/hooks';
import { buildLookupOptions } from '@/config/formOptions';
import { EMPTY_LIST } from '@/lib/utils';

// Everything the Add outgoing-shipment form needs from the server, in one call.
export const useOutgoingShipmentFormOptions = () => {
  const { certificateType, sites, materials, facilityOptions, materialsLoading } =
    useModuleLookups();
  const { data: customers = EMPTY_LIST, isLoading: customersLoading } = useGetCustomersQuery();

  const options = useMemo(
    () => ({
      facilities: facilityOptions,
      customers: buildLookupOptions(customers),
      sites,
      materials,
      certificateType,
    }),
    [facilityOptions, customers, sites, materials, certificateType],
  );

  return {
    options,
    isLoading: materialsLoading || customersLoading,
  };
};
